/** Curated palette and icons for habits (F1). */

export const HABIT_COLORS = [
  "#ef4444",
  "#f97316",
  "#f59e0b",
  "#84cc16",
  "#22c55e",
  "#10b981",
  "#06b6d4",
  "#3b82f6",
  "#6366f1",
  "#8b5cf6",
  "#d946ef",
  "#ec4899",
] as const;

export const HABIT_ICONS = [
  "💪",
  "🏃",
  "🚶",
  "🧘",
  "🚴",
  "🏊",
  "📖",
  "✍️",
  "📚",
  "🎸",
  "🧠",
  "💻",
  "💧",
  "🥗",
  "🍎",
  "😴",
  "🦷",
  "💊",
  "🧹",
  "🌱",
  "🙏",
  "💰",
  "📵",
  "☀️",
] as const;

export const DEFAULT_HABIT_COLOR = HABIT_COLORS[4];
export const DEFAULT_HABIT_ICON = HABIT_ICONS[0];
